const formSanitizeValues = formValues => {
  let sanitizedValues = { ...formValues }

  if (formValues.name) {
    sanitizedValues = {
      ...sanitizedValues,
      name: formValues.name.trim(),
    }
  }

  if (formValues.email) {
    sanitizedValues = {
      ...sanitizedValues,
      email: formValues.email.trim(),
    }
  }

  if (formValues.confirmEmail) {
    sanitizedValues = {
      ...sanitizedValues,
      confirmEmail: formValues.confirmEmail.trim(),
    }
  }

  if (formValues.password) {
    sanitizedValues = {
      ...sanitizedValues,
      password: formValues.password.trim(),
    }
  }

  if (formValues.confirmPassword) {
    sanitizedValues = {
      ...sanitizedValues,
      confirmPassword: formValues.confirmPassword.trim(),
    }
  }

  if (formValues.login) {
    sanitizedValues = {
      ...sanitizedValues,
      login: formValues.login.trim(),
    }
  }

  return sanitizedValues
}

export { formSanitizeValues }
